import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { AiFillDelete, AiOutlineUndo, AiFillEye } from "react-icons/ai";
import axios from "axios";
import { useAuth } from "../../AuthContext";
import { API_BASE_URL } from "../../config";
import Header from "../Header";
import CreditPOPUP from "./CreditPOPUP";

export default function Credit() {
  const { logout } = useAuth();
  const [alltotal_deposit, setalltotal_deposit] = useState("0");
  const [alltotal_credit, setalltotal_credit] = useState("0");
  const [allremaining_balance, setallremaining_balance] = useState("0");
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [savedData, setSavedData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isRole, setIsRole] = useState("false");
  const navigate = useNavigate();

  const [credentials] = useState({
    token: localStorage.getItem("authToken"),
  });

  const fetchfirstdata = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/credit`,
        credentials,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.status) {
        const sortedData = response.data.data.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        setProducts(sortedData);
        setFilteredProducts(sortedData);
        setSavedData(response.data.namesuggestions);

        setalltotal_deposit(response.data.all_total_deposit);
        setalltotal_credit(response.data.all_total_credit);
        setallremaining_balance(response.data.all_remaining_balance);
      }
    } catch (err) {
      logout();
      navigate("/");
    }
  };

  useEffect(() => {
    const authState = localStorage.getItem("authToken");
    if (authState) {
      fetchfirstdata();
      const role = localStorage.getItem("role");
      if (role) {
        setIsRole(role);
      }
    }
  }, []);

  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    setSearchQuery(query);
    const filtered = products.filter((entry) =>
      entry.name.toLowerCase().includes(query)
    );
    setFilteredProducts(filtered);
  };

  const handlePrintPDF = () => {
    const win = window.open('', '_blank');
    if (!win) return;
    const title = 'Credit List';
    const now = new Date().toLocaleString();
    const styles = `
      <style>
        body{font-family: Arial, sans-serif; padding:16px;}
        h2{margin:0 0 8px 0}
        .meta{margin-bottom:16px}
        table{width:100%; border-collapse:collapse;}
        th,td{border:1px solid #ccc; padding:8px; text-align:left;}
        th{background:#f2f2f2}
        tfoot td{font-weight:bold}
      </style>
    `;
    const rows = filteredProducts.map(e => `
      <tr>
        <td>${e.name}</td>
        <td>${e.total_debit ?? '-'}</td>
        <td>${e.total_credit ?? '-'}</td>
      </tr>
    `).join('');
    const html = `
      <html>
        <head>
          <meta charset="utf-8" />
          <title>${title}</title>
          ${styles}
        </head>
        <body>
          <h2>${title}</h2>
          <div class="meta">Generated: ${now}</div>
          <div class="meta">Deposit Total: ${alltotal_deposit} &nbsp;&nbsp; Credit Total: ${alltotal_credit}</div>
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Debit</th>
                <th>Credit</th>
              </tr>
            </thead>
            <tbody>
              ${rows}
            </tbody>
          </table>
          <script>
            window.onload = function(){
              window.print();
              setTimeout(function(){ window.close(); }, 300);
            }
          <\/script>
        </body>
      </html>
    `;
    win.document.open();
    win.document.write(html);
    win.document.close();
  };

  return (
    <>
      <Header />
      <div className="du-detils">
        <div className="container">
            <div className="col-md-12">
              <Link>
                <CreditPOPUP
                  fetchfirstdata={fetchfirstdata}
                  savedData={savedData}
                />
              </Link>
            </div>
  
          <div className="product-form">
            <div className="row">
              <div className="col-md-4 col-12  wi-33p">
                <label>Deposit Total : {alltotal_deposit}</label>
              </div>
              <div className="col-md-4 col-12  wi-33p">
                <label>Credit Total : {alltotal_credit} </label>
              </div>
              <div className="col-md-4 col-12 wi-33p text-end">
                <button className="btn btn-primary" onClick={handlePrintPDF}>Export PDF</button>
              </div>
              {/* <div className="col-md-4 col-12  wi-33p">
                <label>Total : {allremaining_balance}</label>
              </div> */}
            </div>
          </div>
          <div className="show-detils">
            <div className="search-bar">
              <input
                type="text"
                placeholder="Search by name..."
                value={searchQuery}
                onChange={handleSearch}
                className="form-control"
              />
            </div>
            {filteredProducts.length > 0 ? (
              <table className="table table-dark table-striped">
                <thead>
                  <tr>
                    <th>Actions</th>
                    <th>Name</th>
                    <th>Debit</th>
                    <th>Credit</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredProducts.map((entry, i) => (
                    <tr key={i}>
                      <td>
                        <Link
                          className="btn btn-info bt-icon-tab"
                          to={`/creditdetail/${entry.customer_id}`}
                        >
                          <AiFillEye />
                        </Link>
                      </td>
                      <td>{entry.name}</td>
                      <td>{entry.total_debit}</td>
                      <td>{entry.total_credit}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No records found</p>
            )}
          </div>
        </div>
      </div>
      <Header />
    </>
  );
}
